import React, { useEffect } from 'react'
import CheckOutHeader from './CheckOutHeader'
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import pinIcon from 'assets/pinicon.svg'
import cardIcon from 'assets/cardIcon.svg'
import { Form, Row, Col, Button, Spin, message } from 'antd';
import Widget from 'components/Widget'
import { useHistory, useLocation } from 'react-router-dom';
import { DataGetAction, DataRequestAction } from 'redux/actions/http'
import { useDispatch, useSelector } from 'react-redux'
import SimpleModal from 'components/Modal/SimpleModal'
import greenTick from 'assets/images/tick-green@2x.png'
const CheckoutPage = () => {

    const strip = useStripe();
    const elements = useElements();
    const { prevousPage } = useLocation()
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const history = useHistory()
    const signupProps = useSelector(state => state.signUp)
    const { planSettings, isCheckoutSuccess, checkoutSpinner, messageModelVisible, textMessage, isCheckoutError } = signupProps

    const { planName2Price, planName2GST } = planSettings && planSettings !== null ? planSettings : ''



    const fetchplanSettings = () => {
        dispatch(DataGetAction('getPlanSetting', '', 'gettingPlanSettings'));
    }

    useEffect(fetchplanSettings, []);

    const goback = () => {
        if (prevousPage !== 'alreadyFreeUser') {
            history.push({
                pathname: '/subscription',
            })
        }

    }
    const onfinish = (values) => {

        // strip.createToken(cardNumber).then(function (result) {
        //     if (result.error) {
        //         return
        //     }
        //     console.log("=========== result ======", result);
        //     const data = {
        //         totalAmount: parseFloat(planName2Price) + parseFloat(planName2GST), //tipForUb41 + values.careCenterRadio,
        //         tok: result.token.id
        //     }
        //     dispatch(DataRequestAction('POST', 'buyPlan', data, '', 'buyingPlan', false))
        // })

        strip.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardNumberElement),
            billing_details: {
                email: 'collabcare@gmail.com',
            },
        }).then(function (result) {
            console.log("======= result =====",result);
            if (result.error) {
                return
            }

            let dataObj = { 
                payment_method: result.paymentMethod.id 
            }
            values['totalAmount'] = parseFloat(planName2Price) + parseFloat(planName2GST)
            values['stripInfo'] = dataObj;

            dispatch(DataRequestAction('POST', 'buyPlan', values, '', 'buyingPlan', false))

        }).catch(error => {
            console.log("========== error ======", error)
        });

    }

    if (isCheckoutError) {
        message.error(textMessage)
        dispatch({
            type: 'reset_states'
        })
    }

    if (isCheckoutSuccess) {
        dispatch({
            type: 'messageSuccess_modal'
        })
        dispatch({
            type: 'reset_states'
        })
    }
    const toggleModalAndStartQuestionnaire = () => {

        dispatch({
            type: 'messageSuccess_modal',

        })
        dispatch({
            type: 'questionnaire_modal'
        })
        history.push('/questionsModal')
    }
    return (
        <Widget styleName="checkout-card">
            <CheckOutHeader planName2Price={planName2Price} planName2GST={planName2GST} />
            <div className="gx-px-3 gx-py-2 gx-my-2" style={{ borderRadius: '8px', backgroundColor: '#fafafa' }} >
                <div className="gx-d-flex gx-justify-content-between gx-mb-2">
                    <span>Subtotal</span>
                    <span>{planName2Price}</span>
                </div>
                <div className="gx-d-flex gx-justify-content-between">
                    <span>GST/HST</span>
                    <span>{planName2GST}</span>
                </div>
            </div>
            <div className="gx-p-2 gx-mb-4" style={{ borderRadius: '8px', backgroundColor: '#D9F7ED' }} >
                <div className="gx-d-flex gx-justify-content-between">
                    <span>Total amount</span>
                    <span className="gx-d-flex flex-row gx-align-items-end">
                        {+planName2Price + +planName2GST}
                    </span>
                </div>
            </div>
            <Form
                form={form}
                name="requestInspection"
                layout="vertical"
                onFinish={onfinish}
            >
                <Row className="gx-d-flex gx-flex-row gx-mb-3">
                    <Col xl={12} md={12} sm={24} xs={24} style={{ backgroundColor: '#3FD4A2', borderRadius: '8px', color: 'white', padding: '10px' }}>

                        <span className="gx-mb-2 gx-d-inline-block">
                            <img src={pinIcon} alt="icon" />
                        </span>
                        <h3 className="gx-mb-2 gx-font-sans-bold" style={{ color: 'white' }}> <span className="gx-mr-2">1307</span> <span className="gx-mr-2">9113</span> <span className="gx-mr-2">2711</span> <span className="gx-mr-2">6592</span></h3>

                        <div className="gx-font-sans-bold" ><span style={{ fontSize: '9px' }} className="gx-d-block">valid from</span> <span>11/23</span></div>
                        <div className="gx-d-flex gx-justify-content-end">
                            <span><img src={cardIcon} alt="icon" /></span>
                        </div>
                    </Col>
                    <Col xl={12} md={12} sm={24} xs={24} className="gx-m-0 gx-pr-0" style={{ display: 'grid', alignContent: 'center' }}>
                        <Row >
                            <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                                <div className="cardNumber">
                                    <CardNumberElement
                                        options={{
                                            style: {

                                                base: {
                                                    border: '1px solid red !important',
                                                    '::placeholder': {
                                                        color: '#aab7c4',
                                                    },
                                                },
                                                invalid: {
                                                    color: '#9e2146',
                                                },
                                            },
                                        }}
                                    />
                                </div>

                            </Col>
                        </Row>
                        <Row className="gx-mx-0 gx-mt-3 gx-d-flex gx-flex-row">
                            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-pl-0">
                                <div className="cardNumber">
                                    <CardExpiryElement
                                        options={{
                                            style: {
                                                base: {
                                                    fontSize: '16px',
                                                    color: '#424770',
                                                    '::placeholder': {
                                                        color: '#aab7c4',
                                                    },
                                                },
                                                invalid: {
                                                    color: '#9e2146',
                                                },
                                            },
                                        }}
                                    />
                                </div>
                            </Col>
                            <Col xl={12} lg={12} md={12} sm={24} xs={24} className="gx-px-0">
                                <div className="cardNumber">
                                    <CardCvcElement
                                        options={{
                                            style: {
                                                base: {
                                                    fontSize: '16px',
                                                    color: '#424770',
                                                    '::placeholder': {
                                                        color: '#aab7c4',
                                                    },
                                                },
                                                invalid: {
                                                    color: '#9e2146',
                                                },
                                            },
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>

                    </Col>
                </Row>
                <Row>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24} className="gx-px-0">
                        <div className="gx-flex gx-flex-row gx-align-items-center gx-justify-content-between ">
                            <Form.Item className="gx-mb-0">
                                <Button type="default" className="gx-pt-0 gx-mb-0" onClick={() => goback()} >
                                    Change Plan
                                    </Button>
                            </Form.Item>

                            <Form.Item className="gx-mb-0">

                                {!checkoutSpinner && <Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="submit">
                                    checkout
                                    </Button>}
                                {checkoutSpinner && <Spin><Button type="primary" className="gx-pt-0 gx-mb-0" htmlType="button" disabled>
                                    checkout
                                    </Button></Spin>}
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>

            <SimpleModal

                modalFor="messageSuccess_modal"
                visible={messageModelVisible}
                width={350}
                closable={false}
                maskClosable={false}
                className=""

            >
                <div className="gx-d-flex gx-flex-column gx-align-items-center gx-justify-content-center gx-py-3 gx-px-5">
                    <img src={greenTick} alt="" className="gx-mb-3" />
                    <p className="gx-blue-font gx-font-weight-bold gx-mb-4">Your payment was successful</p>
                    <Button type="primary" className="gx-mb-0 gx-pt-0" onClick={() => toggleModalAndStartQuestionnaire()}>Ok</Button>
                </div>




            </SimpleModal>



        </Widget>
    )
}

export default CheckoutPage
